import { render, staticRenderFns } from "./ServicesTable.vue?vue&type=template&id=1d8718f4&"
import script from "./ServicesTable.vue?vue&type=script&lang=js&"
export * from "./ServicesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d8718f4')) {
      api.createRecord('1d8718f4', component.options)
    } else {
      api.reload('1d8718f4', component.options)
    }
    module.hot.accept("./ServicesTable.vue?vue&type=template&id=1d8718f4&", function () {
      api.rerender('1d8718f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/ServicesPage/ServicesTable.vue"
export default component.exports